import {makeAutoObservable} from "mobx";
import AppealService from "../services/AppealService";
import ProviderService from "../services/ProviderService";
import { socket } from "../socket";
import BillingService from "../services/BillingService";

class AppealsStore {
    
    appeal = {};
    appeals = [];
    isLoading = false;
    providers = []
    billings = []
    appealGroups = []

    paginationModel = {
        pageSize: 20,
        page: 1,
    };
    paginationModelAppealsComments = {
        pageSize: 20,
        page: 1,
    };
    filterModel = {
        provider: 0,
        group: 0,
        open: 1,
        close: 0,
        filter: '',
    };

    constructor() {
        makeAutoObservable(this)
        this.fetchAppeals()
        socket.on("appeal_update", (data) => {
            this.fetchAppeals()
            if (data.appeal_id === this.appeal.id) {
                this.fetchAppeal(this.appeal)
                // dispatch(FetchDirectConversations({ conversations: data }));
            }
        });
        
        this.isLoading = true
    }

    setFilterModel(filterModel) {
        this.filterModel = filterModel;
        this.fetchAppeals()
    }

    setPaginationModel(paginationModel) {
        this.paginationModel = paginationModel;
        this.fetchAppeals()
    }

    setAppeal(apeal) {
        this.appeal = apeal
    }

    setProviders(providers) {
        this.providers = providers
    }
    
    setBillings(billings) {
        this.billings = billings
    }

    getProviders() {
        if (this.providers.length === 0) {
            this.fetchProviders()
        }
        return this.providers
    }

    getBillings(provider_id) {
        if (this.billings.length === 0) {
            this.fetchBillings()
        }
        if (provider_id) {
            return this.billings.filter(billing => billing.provider_id === provider_id)
        }
        return this.billings
    }

    setAppealGroups(appealGroups) {
        this.appealGroups = appealGroups
    }

    getAppealGroup() {
        if (this.appealGroups.length === 0) {
            this.fetchAppealGroups()
        }
        return this.appealGroups
    }
    

    async fetchAppeal( appeal ) {
        try {
            const response = await AppealService.getAppealComments(
                appeal.id,
                this.paginationModelAppealsComments.page,
                this.paginationModelAppealsComments.pageSize
            );
            this.appeal = appeal;
            this.appeal.comments = response.data.comments.reverse()
            this.appeal.comments_count = response.data.totalCount
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async fetchAppeals(  ) {
        try {
            const appeals = await AppealService.getAppeals(
                this.paginationModel, this.filterModel
            );
            this.appeals = appeals.data.appeals;
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async fetchNextAppeals() {
        try {
            if (this.appeals.length % this.paginationModel.pageSize === 0) {
                const nextPage = this.appeals.length / this.paginationModel.pageSize + 1
                const paginationModel = {
                    pageSize: this.paginationModel.pageSize,
                    page: nextPage,
                }
                const appeals = await AppealService.getAppeals(paginationModel, this.filterModel);
                this.appeals = this.appeals.concat(appeals.data.appeals);
            }   
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async fetchNextAppealsComment() {
        try {
            if (this.appeal.comments.length % this.paginationModelAppealsComments.pageSize === 0) {
                const nextPage = this.appeal.comments.length / this.paginationModelAppealsComments.pageSize + 1
                const response = await AppealService.getAppealComments(
                    this.appeal.id,
                    nextPage,
                    this.paginationModelAppealsComments.pageSize
                );
                this.appeal.comments = response.data.comments.reverse().concat(this.appeal.comments);
            }
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async fetchProviders() {
        try {
            const providers = await ProviderService.getProviders();
            this.setProviders(providers.data.providers)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async fetchBillings() {
        try {
            const billings = await BillingService.getBillings();
            this.setBillings(billings.data.billings)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async fetchAppealGroups() {
        try {
            const appealGroups = await AppealService.getAppealGroup();
            this.setAppealGroups(appealGroups.data.appeal_groups)
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async sendMessage(appealId, message) {
        try {
            return await AppealService.postAppealComments(
                appealId,
                message
            );
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

    async putAppeal(appealId, appeal) {
        try {
            return await AppealService.putAppeal(
                appealId,
                appeal
            );
        } catch (e) {
            console.log(e.response?.data?.message)
        }
    }

}

export default new AppealsStore()